import isEqual from 'fast-deep-equal';
import { onMount } from 'svelte';
import { derived, get, writable } from 'svelte/store';
import { defineStudioUrlStore } from './defineStudioUrlStore';
import { useEncodeDataAttribute } from './useEncodeDataAttribute';
export function defineUseQuery({ createFetcherStore, studioUrlStore, }) {
    const DEFAULT_PARAMS = {};
    const DEFAULT_OPTIONS = {};
    return (query, params = DEFAULT_PARAMS, options = DEFAULT_OPTIONS) => {
        if (typeof query === 'object') {
            params = query.params || DEFAULT_PARAMS;
            options = query.options || DEFAULT_OPTIONS;
            query = query.query;
        }
        const initial = options.initial
            ? {
                perspective: 'published',
                ...options.initial,
            }
            : undefined;
        const $params = JSON.stringify(params);
        // Core loader fetcher store
        const $fetcher = createFetcherStore(query, JSON.parse($params), initial);
        // If $fetcher were returned directly, svelte would trigger the nanostores onMount method
        // on the server, so create a new store and keep it in sync
        const $writeable = writable($fetcher.value);
        // Only call subscribe on the client
        onMount(() => $fetcher.subscribe((snapshot) => {
            const prev = get($writeable);
            if (prev.error !== snapshot.error) {
                $writeable.set(snapshot);
            }
            if (prev.loading !== snapshot.loading) {
                $writeable.set(snapshot);
            }
            if (prev.perspective !== snapshot.perspective) {
                $writeable.set(snapshot);
            }
            if (!isEqual(prev.data, snapshot.data)) {
                $writeable.set(snapshot);
            }
        }));
        // Return the store data with encodeDataAttribute
        return derived([$writeable, studioUrlStore], ([value, studioUrl]) => ({
            ...value,
            encodeDataAttribute: useEncodeDataAttribute(value.data, value.sourceMap, studioUrl),
        }));
    };
}
